export default __webpack_public_path__ + "static/media/ontime-logo.02a18828.png";